import './product-technology.component.pug'
import './product-technology.component.scss'

const productTechnology = document.querySelectorAll('.product-technology')
if (productTechnology.length > 0) {
  import(
    /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
  ).then(({ ScrollMagic }) => {
    productTechnology.forEach((root) => {
      const controller = new ScrollMagic.Controller()
      const scene = new ScrollMagic.Scene({
        duration: root.getBoundingClientRect().height,
        triggerElement: root
      }).addTo(controller)

      scene.on('enter', function (event) {
        if (event.state === 'DURING' && event.scrollDirection === 'FORWARD') {
          root.classList.add('dark-mode')
        }
      })
      scene.on('leave', function (event) {
        if (event.state === 'BEFORE' && event.scrollDirection === 'REVERSE') {
          root.classList.remove('dark-mode')
        }
      })
    })
  })
}
